import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import './navigation.css'

const Navigation = ({ rootClassName }) => {
  const [mobileOpen, setMobileOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  const navLinks = [
    { to: '/', label: 'Aktuelle' },
    // { to: '/mitmachen', label: 'Mitmachen' },
    { to: '/kontakt', label: 'Kontakt' },
    { to: '/ueber-uns', label: 'Über uns' },
    { to: '/datenschutz', label: 'Datenschutz' },
  ]

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : ''
    return () => (document.body.style.overflow = '')
  }, [mobileOpen])

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 80)
    }
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <>
      <div className="navigation-hero">
        <img
          src="/media/hero.jpg"
          alt="Hero"
          className="navigation-hero-image"
        />
      </div>

      <nav
        className={`navigation ${scrolled ? 'navigation-fixed' : ''} ${rootClassName}`}
      >
        <div className="navigation-container">
          {/* Logo */}
          <NavLink to="/" className="navigation-logo-link" onClick={() => setMobileOpen(false)}>
            <div className="navigation-logo">
              <div className="navigation-logo-icon">
                <img src="/media/logo.jpeg" alt="Logo" className="navigation-flag-emblem" />
              </div>
              <div className="navigation-logo-text">
                <span className="logo-title">Stimme Georgiens</span>
                <span className="logo-subtitle">Initiativgruppe</span>
              </div>
            </div>
          </NavLink>

          {/* Desktop */}
          <div className="navigation-links">
            {navLinks.map((link) => (
              <NavLink key={link.to} to={link.to} className="navigation-link">
                {link.label}
              </NavLink>
            ))}
          </div>

          {/* Mobile Toggle */}
          <button className="navigation-toggle" onClick={() => setMobileOpen(true)}>
            ☰
          </button>

          {/* Mobile Overlay */}
          <div className={`navigation-mobile-overlay ${mobileOpen ? 'navigation-open' : ''}`}>
            <div className="navigation-mobile-header">
              <button className="navigation-close" onClick={() => setMobileOpen(false)}>✕</button>
            </div>
            <div className="navigation-mobile-links">
              {navLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className="navigation-mobile-link"
                  onClick={() => setMobileOpen(false)}
                >
                  {link.label}
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}

Navigation.propTypes = {
  rootClassName: PropTypes.string,
}

export default Navigation
